<template>
  <div>
    <Navbar></Navbar>
    <div class="content">
      <div class="section_1">
        <div class="_t title">Lighter is better</div>
        <a href="#section_4" class="tag _p">Learn how light the Heart Smart<span style="font-size: 0.18rem;">™</span> monitor is </a>
        <div class="img">
          <img src="@/assets/2.0/mobile/section_1_bg.jpg" />
        </div>
      </div>
      <div class="section_2">
        <div class="_t">
          <p style="position: relative;">Heart Smart<span style="font-size: 0.36rem;position: absolute;top: 0.1rem;">™</span></p>
          <p>for You</p>
        </div>
        <div class="_p">
          <p>·Exceptional detection accuracy</p>
          <p>·Light and comfort design</p>
          <p>·Secure and fast data intelligence</p>
        </div>
      </div>
      <div class="section_3">
        <div class="img">
          <img src="@/assets/2.0/mobile/section_2_bg.jpg" />
        </div>
      </div>
      <div class="section_4" id="section_4">
        <div class="trait-list">
        <div class="trait-item">
          <div class="circle">1</div>
          <div class="text-box">
            <div class="title-text">Connect it</div>
            <div class="info-text">
              <p>Connect the monitor</p>
              <p>to cell phone</p>
            </div>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-01.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">2</div>
          <div class="text-box">
            <div class="title-text">Wear it</div>
            <div class="info-text">
              <p>Wear the monitor patch</p>
              <p>to your chest</p>
            </div>
         </div>
          <div class="img-info" style="right: 0.23rem;"><img src="@/assets/2.0/icon-03.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">3</div>
          <div class="text-box">
            <div class="title-text">Use it</div>
            <div class="info-text">
              <p>Monitor your heart and</p>
              <p>stress at anytime</p>
            </div>
          </div>
          <div class="img-info" style="right: 0.05rem;"><img src="@/assets/2.0/icon-02.svg" /></div>
        </div>
        </div>
      </div>
      <div class="section_5">
        <div class="_t" style="fontSize: 0.6rem;">
          <p>Lightest heart</p>
          <p>monitor</p>
          <p>with superior accuracy</p>
        </div>
        <div class="_p">
          <p>We provide you three benefits only available</p>
          <p>with Heart Smart™</p>
        </div>
        <div class="img">
          <img src="@/assets/2.0/mobile/icon_group.png" />
        </div>
        <div class="img" style="margin-top: 1rem;">
          <img src="@/assets/2.0/mobile/table.png" />
        </div>
      </div>
      <div class="section_7">
        <div class="title _t">
          <p>Smallest and</p>
          <p>lightest ECG</p>
          <p>ever seen</p>
          <p>and it will</p>
          <p>renovate patient</p>
          <p>experience.</p>
        </div>
        <div class="img"><img src="@/assets/2.0/mobile/section_6_bg.png" /></div>
      </div>
      <div class="section_6">
        <div class="title _t">
          <p>I can't feel</p>
          <p>it and</p>
          <p>it works.</p>
        </div>
        <div class="img"><img src="@/assets/2.0/mobile/section_5_bg.jpg" /></div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";

export default {
  name: "index",
  components: { Navbar,FooterDom },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    toPage(path) {
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  font-size: 0;
  ._t {
    font-size: 0.8rem;
    color: #000;
  }
  ._p{
    font-size: 0.22rem;
    color: #000;
    line-height: 0.4rem;
  }
  .img{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .section_1{
    background: #efefef;
    height: 9.57rem;
    width: 100%;
    position: relative;
    .title{
      padding-top: 0.88rem;
      width: 100%;
      text-align: center;
      position: relative;
      z-index: 2;
    }
    .tag{
      display: block;
      position: relative;
      z-index: 2;
      margin: 0.4rem auto 0 auto;
      border-radius: 0.24rem;
      padding: 0.15rem 0.30rem;
      border: 1px solid #4FC78B;
      text-align: center;
      width: fit-content;
      font-size: 0.24rem;
      font-family: "Light";
    }
    .img{
      position: absolute;
      top:0;
      z-index: 1;
    }
  }
  .section_2{
    background: #fff;
    padding: 0.8rem 0.74rem;
    .t{
      font-size: 0.7rem;
    }
    ._p{
     margin-top: 0.6rem;
      font-size: 0.24rem;
  }
  }
  .section_3{
    background: #efefef;
    width: 100%;
  }
  .section_4{
    background: #efefef;
    background: url("../../assets/2.0/mobile/section_3_bg.jpg") no-repeat;
    background-size: cover;
    padding: 0.64rem 0;
    display: flex;
    align-items: center;
    .trait-list{
      width: 100%;
      padding: 0 0.78rem;
      .trait-item{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px dashed #4D4D4E;
        padding: 0.78rem 0.1rem 0.78rem 0;
        position: relative;
        &:last-child{
          border-bottom: none;
        }
        .circle{
          width: 0.57rem;
          height: 0.57rem;
          line-height: 0.57rem;
          font-size: 0.36rem;
          border: 0.5px solid #000;
          color: #000;
          border-radius: 0.57rem;
          text-align: center;
          margin-right: 0.78rem;
          font-family: "Light";
        }
        .text-box{
          margin-right: 20%;
          .title-text{
            font-size: 0.5rem;
            margin-bottom: 0.1rem;

          }
          .info-text{
            font-size: 0.26rem;
          }
        }
        .img-info{
          height: 1.02rem;
          position: absolute;
          right: 0.2rem;
          img{
            height: 100%;
          }
        }
      }
    }
  }
  .section_5{
    background: #fff;
    padding: 0.6rem 0.74rem;
    ._p{
      margin-top: 0.2rem;
    }
    .img{
      margin-top: 0.8rem;
    }
  }
  .section_6{
    position: relative;
    .title{
      position: absolute;
      left: 0.78rem;
      top: 0.78rem;
      font-size: 0.7rem;
    }
  }
  .section_7{
    position: relative;
    .title{
      position: absolute;
      left: 0.78rem;
      top: 0.78rem;
      font-size: 0.4rem;
      line-height: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/index.vue